export default "__VITE_PUBLIC_ASSET__a5d57f58__"